export const STATUS_META = {
  pending: { label: "Pending", color: "bg-amber-100 text-amber-700" },
  accepted: { label: "Accepted", color: "bg-blue-100 text-blue-700" },
  preparing: { label: "Preparing", color: "bg-indigo-100 text-indigo-700" },
  ready: { label: "Ready", color: "bg-purple-100 text-purple-700" },
  out_for_delivery: { label: "Out for delivery", color: "bg-cyan-100 text-cyan-700" },
  completed: { label: "Completed", color: "bg-green-100 text-green-700" },
  cancelled: { label: "Cancelled", color: "bg-red-100 text-red-600" },
};
export const ALL_STATUSES = ["pending", "accepted", "preparing", "ready", "out_for_delivery", "completed", "cancelled"];

export function StatusBadge({ status, testid }) {
  const m = STATUS_META[status] || STATUS_META.pending;
  return <span data-testid={testid} className={`text-xs font-semibold px-2.5 py-1 rounded-full ${m.color}`}>{m.label}</span>;
}
